/* eslint-disable react/prop-types */
import React, { Fragment, useCallback, useMemo, useRef, useState } from 'react';
import { isEmpty, omit } from 'ramda';

import Input from '../Input';
import Notification from '../../../common/components/Notification';

import { Wrapper, ButtonsWrappers, Left, StateDescription } from './styled-components';
import Button from '../Button';
import {
  LocalStorage,
  retrieveAllUriParams,
  updateUserLastAction
} from '../../../../utils/helpers';
import { confirmNewPassword, resetPassword, signUserIn } from '../../../../core/auth/util';
import { CenteredRow } from '../../layouts/AuthFlow/styled-components';

const ForgotPasswordBox = ({ confirm, validatePassword }) => {
  const params = retrieveAllUriParams();
  const [errorMessage] = useState();
  const [buttonText, setButtonText] = useState('Send Email Link');
  const [password, setPassword] = useState();
  const [passwordConfirm, setPasswordConfirm] = useState();
  const [userTokens, setUserTokens] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const formRef = useRef();
  const username = useMemo(() => LocalStorage.get('user.username'), [LocalStorage]);
  const [email, setEmail] = useState(username);
  const onContinue = useCallback(
    async () => {
      setIsDisabled(true);
      if (confirm) {
        setButtonText('Submitting');
        const results = validatePassword({ password, passwordConfirm });
        if (isEmpty(results)) {
          await confirmNewPassword({ username: email, password });
          const { userTokens: tokens } = await signUserIn({ username, password, new_password: '' });
          setUserTokens(tokens);
          setIsRedirecting(true);
        }
      } else {
        setButtonText('Sending');
        await resetPassword({ username: email });
        if (params.redirect_url) {
          updateUserLastAction({
            email,
            redirectUri: params.redirect_url
          });
        }
        setButtonText('Send Email Link');
        setIsCompleted(true);
      }
      setIsDisabled(false);
    },
    [email]
  );
  const redirectUri = useMemo(
    () =>
      `${params.redirect_uri}?${new URLSearchParams(
        omit(['redirect_uri', 'client_id'], params)
      ).toString()}`,
    [params]
  );
  return (
    <Wrapper>
      {confirm && (
        <Fragment>
          <ButtonsWrappers center="xs">
            <StateDescription>Enter a new password below to continue.</StateDescription>
          </ButtonsWrappers>
          <ButtonsWrappers center="xs">
            <Left xs={8}>
              <Input
                type="text"
                name="email"
                required
                value={email}
                placeholder="Email"
                onChange={e => {
                  setEmail(e.target.value);
                }}
              />
              <Input
                type="text"
                name="password"
                required
                value={password}
                placeholder="New Password"
                onChange={e => {
                  setPassword(e.target.value);
                }}
              />
              <Input
                type="text"
                name="confirmPassword"
                required
                value={passwordConfirm}
                placeholder="Confirm New Password"
                onChange={e => {
                  setPasswordConfirm(e.target.value);
                }}
              />
            </Left>
          </ButtonsWrappers>
          {errorMessage && (
            <ButtonsWrappers center="xs">
              <Left xs={8}>
                <Notification message={errorMessage} />
              </Left>
            </ButtonsWrappers>
          )}
          <ButtonsWrappers center="xs">
            <Left xs={8}>
              <Button
                name="continue"
                label="Confirm New Password"
                onClick={onContinue}
                primary
                disabled={isDisabled}
              />
            </Left>
          </ButtonsWrappers>
        </Fragment>
      )}
      {!isCompleted &&
        !confirm && (
          <Fragment>
            <ButtonsWrappers center="xs">
              <StateDescription>
                {
                  'Forgot your password? Click the button below and we’ll send you an email with a link to reset your password.'
                }
              </StateDescription>
            </ButtonsWrappers>
            <ButtonsWrappers center="xs">
              <Left xs={8}>
                <Input
                  type="text"
                  name="email"
                  required
                  value={email}
                  placeholder="Email"
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                />
              </Left>
            </ButtonsWrappers>
            {errorMessage && (
              <ButtonsWrappers center="xs">
                <Left xs={8}>
                  <Notification message={errorMessage} />
                </Left>
              </ButtonsWrappers>
            )}
            <ButtonsWrappers center="xs">
              <Left xs={8}>
                <Button
                  name="continue"
                  label={buttonText}
                  onClick={onContinue}
                  primary
                  disabled={isDisabled}
                />
              </Left>
            </ButtonsWrappers>
          </Fragment>
        )}
      {isCompleted && (
        <Fragment>
          <CenteredRow center="xs">
            <StateDescription>
              {'Please check your email to complete the password reset.'}
            </StateDescription>
          </CenteredRow>
          <CenteredRow center="xs">
            <StateDescription>
              {
                'The email may take a few minutes to show up in your inbox. If you don’t receive the email in a few minutes, please check your SPAM folder.'
              }
            </StateDescription>
          </CenteredRow>
        </Fragment>
      )}
      {isRedirecting && (
        <Fragment>
          <CenteredRow center="xs">
            <StateDescription>
              {'Login Success! Returning you back to the application.'}
            </StateDescription>
          </CenteredRow>
          <form method="POST" action={redirectUri} ref={formRef}>
            <input type="hidden" name="idToken" value={userTokens.idToken} />
            <input type="hidden" name="accessToken" value={userTokens.accessToken} />
            <input type="hidden" name="refreshToken" value={userTokens.refreshToken} />
            <input type="hidden" name="redirectUri" value={params.redirectUri} />
          </form>
        </Fragment>
      )}
    </Wrapper>
  );
};

ForgotPasswordBox.defaultProps = {
  onInputChange: () => {}
};

export default ForgotPasswordBox;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/ForgotPasswordBox/index.js